import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { NotificationsService } from "angular2-notifications";

@Injectable()
export class AppInterceptor implements HttpInterceptor {

    constructor(private notificationService: NotificationsService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next
            .handle(req)
            .do(event => {
                if (event instanceof HttpResponse && event.body.hasOwnProperty('messages')) {
                    event.body.messages.map((message) => {
                        if (event.body.status === false) {
                            return this.notificationService.error('Error', message);
                        }
                        return this.notificationService.success('Success', message);
                    });
                }
            });
    }

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/app.interceptor.ts